<script setup lang="ts">
const props = defineProps({
  hoverable: {
    type: Boolean,
    default: true,
  },
  outline: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="ui-card" :class="{ outline: props.outline, hoverable: props.hoverable }">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.ui-card {
  background: rgb(var(--card-background));
  border-radius: var(--large-border-radius);
  padding: 30px;
  transition: 0.2s;

  &.outline {
    border: 1px solid rgba(var(--card-outline-color), 0.4);
  }

  &.hoverable {
    cursor: pointer;

    &:hover {
      background: rgb(var(--card-hover-background));

      &.outline {
        border-color: rgba(var(--card-hover-outline-color), 0.4);
      }
    }
  }
}
</style>